import React from 'react';
import clsx from 'clsx';
import identity from 'lodash/identity';

export default function Tooltip({ active, label, payload = [], totalData, dataFormat = identity, showPercentage }) {
  if (active) {
    return (
      <div className="bg-white p-3 shadow-lg">
        {!!label && <h3 className="h4 mb-2 fw-bolder text-start">{label}</h3>}
        {payload.map((p, i) => {
          const color = p.fill || p.payload?.fill || p.payload?.color;
          return p.value ? (
            <div key={i} className={clsx('fw-bolder', i !== payload.length - 1 && 'mb-2')}>
              <span style={{ color }}>
                {p.name}:
              </span>
              {' '}
              {!!showPercentage ? (
                <span style={{ color }}>{parseFloat(p.value/totalData * 100).toFixed(1)}% ({dataFormat(p.value)})</span>
              ) : (
                <span style={{ color }}>{dataFormat(p.value)}</span>
              )}
            </div>
          ) : null;
        })}
      </div>
    );
  }

  return null;
}
